// import React, { Component } from "react";
// import {
//   Modal,
//   Card,
//   Col,
//   Row,
//   Form,
//   Button,
//   Table,
//   Container,
// } from "react-bootstrap-v5";
// import "react-bootstrap-typeahead/css/Typeahead.css";
// import { toast } from "react-toastify";
// import moment from "moment";
// import Select from "react-select";
// import { FaStreetView } from "react-icons/fa";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import JobService from "../../Services/JobService";
// import { revenuecostService } from "../../Services/revenuecostService";

// class InvoiceByJob extends Component {
//   state = {
//     showInvoiceModal: false,
//     jobList: [],
//     showModal: false,
//     date: "",
//     account_name: {},
//     amount: 0,
//     qbInvoiceId: 0,
//     invoiceId: 0,
//     qbCustId: 0,
//     listSelect: [
//       { value: "81", label: "ENBD BANK" },
//       { value: "83", label: "CASH IN HAND" },
//       { value: "84", label: "RAK BANK" },
//     ],
//     valamount: false,
//     valaccount_name: false,
//     valdate: false,
//     invoiceView: null,
//   };

//   componentDidMount() {
//     this.getJobList();
//   }

//   getJobList = () => {
//     const query = new URLSearchParams(this.props.location.search);
//     let jobId = query.get("id");
//     let param = { jobId, limit: 1000, page: 1 };
//     JobService.getPayInvoiceByJob(param).then((result) => {
//       if (result.status === true) {
//         this.setState({ jobList: result.data });
//       }
//     });
//   };

//   handleShow = (value) => {
//     this.setState({ showModal: value });
//   };

//   handleInputChange(e) {
//     if (Object.keys(e)[1] === "label") {
//       this.setState({ account_name: e, valaccount_name: false });
//     } else {
//       this.setState({ [e.target.name]: e.target.value, valdate: false, valamount: false });
//     }
//   }

//   handlePay = (index, qbInvoiceId, invoiceId, qbCustId) => {
//     this.setState({ showModal: true, qbInvoiceId, invoiceId, qbCustId });
//   };

//   handleInvoice = (value, index) => {
//     this.setState({ showInvoiceModal: value, invoiceView: index });
//   };

//   downloadInvoicePDF = () => {
//     const invoiceElement = document.getElementById("invoice-content");
//     html2canvas(invoiceElement, { scale: 2 }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
//       const imgWidth = 210;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;
//       pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//       pdf.save("invoice.pdf");
//     });
//   };

//   render() {
//     const { jobList, showInvoiceModal, showModal } = this.state;
//     return (
//       <Card>
//         <Card.Body>
//           <Row>
//             <Col>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>S.No</th>
//                     <th>Job Token</th>
//                     <th>Status</th>
//                     <th>Invoice Amount</th>
//                     <th>Balance</th>
//                     <th>Paid</th>
//                     <th>Date</th>
//                     <th>#</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {jobList.length > 0 &&
//                     jobList.map((item, index) => (
//                       <tr key={index}>
//                         <td>{index + 1}</td>
//                         <td>{item.job_token}</td>
//                         <td>{item.status}</td>
//                         <td>{item.amount}</td>
//                         <td>{item.balance}</td>
//                         <td>{item.paid}</td>
//                         <td>{moment(item.dateAt).format("YYYY-MM-DD")}</td>
//                         {item.balance > 0 && (
//                           <td>
//                             <Button onClick={() => this.handlePay(index, item.qbInvoiceId, item._id, item.qbCustId)}>
//                               Receive
//                             </Button>
//                             <Button onClick={() => this.handleInvoice(true, index)} className="m-1">
//                               <FaStreetView />
//                             </Button>
//                           </td>
//                         )}
//                       </tr>
//                     ))}
//                   {jobList.length === 0 && (
//                     <tr>
//                       <td colSpan={7}>Not Found</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </Table>
//             </Col>
//           </Row>

//           <Modal size="xl" show={showInvoiceModal} onHide={() => this.handleInvoice(false)}>
//             <Modal.Header closeButton>
//               <Modal.Title>Invoice</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               <Container id="invoice-content">
//                 <h6>Kens World2Door Cargo LLC</h6>
//                 <p>508, Dusseldorf Business Point Bldg, Al Barsha 1, Dubai, DUBAI 454487 ARE</p>
//                 <p>Receipt</p>
//                 <Table bordered>
//                   <thead>
//                     <tr>
//                       <th>Invoice Number</th>
//                       <th>Invoice Date</th>
//                       <th>Payment</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <tr>
//                       <td>2167</td>
//                       <td>01/31/2025</td>
//                       <td>600.00</td>
//                     </tr>
//                   </tbody>
//                 </Table>
//                 <hr className="border-top-dotted" />
//                 <div className="d-flex justify-content-between">
//                   <div>Memo:</div>
//                   <div>BALANCE DUE</div>
//                   <div>AED0.00</div>
//                 </div>
//               </Container>
//               <Button className="mt-3" onClick={this.downloadInvoicePDF}>
//                 Download PDF
//               </Button>
//             </Modal.Body>
//           </Modal>
//         </Card.Body>
//       </Card>
//     );
//   }
// }

// export { InvoiceByJob };

import React, { Component } from "react";
import {
  Modal,
  Card,
  Col,
  Row,
  Form,
  Button,
  Table,
  Container,
} from "react-bootstrap-v5";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { toast } from "react-toastify";
import moment from "moment";
import Select from "react-select";
import JobService from "../../Services/JobService";
import { revenuecostService } from "../../Services/revenuecostService";
import { FaDownload, FaStreetView } from "react-icons/fa";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReceiptHtml from "./receipt";
import DownloadPayInvoice from "./DownloadPayInvoice";
import { renderToString } from "react-dom/server";

class InvoiceByJob extends Component {
  state = {
    data: {},
    showInvoiceModal: false,
    showReceiptModal: false,
    jobList: [],
    receiptIndex : 0,
    showModal: false,
    date: "",
    account_name: {},
    amount: 0,
    qbInvoiceId: 0,
    invoiceId: 0,
    qbCustId: 0,
    listSelect: [
      { value: "81", label: "ENBD BANK" },
      { value: "83", label: "CASH IN HAND" },
      { value: "84", label: "RAK BANK" },
      { value: "105", label: "CASH FROM SALES-TELR" },
      { value: "156", label: "NETWORK INTERNATIONAL" },
    ],
    valamount: false,
    valaccount_name: false,
    valdate: false,
  };
  componentDidMount() {
    this.getJobList();
  }

  getJobList = () => {
    const query = new URLSearchParams(this.props.location.search);
    let jobId = query.get("id");
    let param = { jobId };
    param["limit"] = 1000;
    param["page"] = 1;
    JobService.getPayInvoiceByJob(param).then((result) => {
      if (result.status === true) {
        this.setState({ jobList: result.data });
      }
    });
  };

  handleShow = (value) => {
    this.setState({ showModal: value });
  };

  handleInputChange(e) {
    if (Object.keys(e)[1] === "label") {
      this.setState({ account_name: e });
      if (Object.keys(this.state.account_name).length >= 0) {
        this.setState({ valaccount_name: false });
      }
    } else {
      this.setState({ [e.target.name]: e.target.value });
      if (this.state.date.length >= "") {
        this.setState({ valdate: false });
      }
      if (this.state.amount >= 0) {
        this.setState({ valamount: false });
      }
    }
  }

  handlePay = (index, qbInvoiceId, invoiceId, qbCustId) => {
    this.handleShow(true);
    this.setState({ qbInvoiceId, invoiceId, qbCustId });
  };

  handleInvoice = (value, index, item) => {
    // this.setState({ data: item });
    // this.setState({ data: item }, () => {
    //   console.log(this.state.data, "Updated data");
    // });
    if (value === true) {
      this.setState({ showInvoiceModal: value, receiptIndex: index });
    } else {
      this.setState({ showInvoiceModal: value });
    }
  };
  handleInvoiceReceipts = (value, item) => {
    this.setState({ showReceiptModal: value, data: item });
  };

  payInvoice = () => {
    if (this.state.date.length <= "") {
      this.setState({ valdate: true });
    }
    if (Object.keys(this.state.account_name).length <= 0) {
      this.setState({ valaccount_name: true });
    }
    if (this.state.amount <= 0) {
      this.setState({ valamount: true });
    }
    if (
      this.state.date.length <= "" ||
      Object.keys(this.state.account_name).length <= 0 ||
      this.state.amount <= 0
    ) {
      return false;
    }
    let bal = this.state.jobList.find(
      (item, i) => item._id === this.state.invoiceId
    );
    if (this.state.amount > bal.balance) {
      toast.error(`Amount is greater than payable amount`);
    }

    const { qbInvoiceId, invoiceId, date, account_name, amount, qbCustId } =
      this.state;
    const query = new URLSearchParams(this.props.location.search);
    let jobId = query.get("id");

    let invoiceReq = {
      qbCustId,
      date: date,
      account_name: account_name.value,
      totalAmt: amount,
      qbInvoiceId,
      jobId,
    };
    revenuecostService.invoicePayment(invoiceReq).then((invoiceRes) => {
      if (invoiceRes.status === true) {
        let postData = {
          date: date,
          id: invoiceId,
          amount: amount,
          job_id: jobId,
          final_balance:
            this.state.jobList.reduce(
              (acc, cur) => (acc += Number(cur.balance)),
              0
            ) - amount,
        };
        revenuecostService.updateStatus(postData).then((result) => {
          if (result.status === true) {
            this.getJobList();
            this.handleShow(false);
            toast.success(invoiceRes.message);
          } else {
            toast.error(invoiceRes.message);
          }
        });
      } else {
        toast.error(invoiceRes.message);
      }
    });
  };

  //    downloadInvoicePDF = () => {
  //    const invoiceElement = document.getElementById("invoice-content");
  //    console.log(invoiceElement, "invoiceElement")
  //    html2canvas(invoiceElement, { scale: 2 }).then((canvas) => {
  //      const imgData = canvas.toDataURL("image/png");
  //      const pdf = new jsPDF("p", "mm", "a4");
  //      const imgWidth = 210;
  //      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
  //      pdf.save("invoice.pdf");
  //    });
  //  };

  downloadPdf = async (index) => {
    const doc = new jsPDF();

    // Convert React component to HTML string
    const htmlString = renderToString(<DownloadPayInvoice data={this.state.data} receiptIndex={index} />);

    await doc.html(htmlString, {
      callback: (pdf) => {
        pdf.save("receipt.pdf"); // Save the PDF file
      },
      html2canvas: { scale: 0.24 },
      // html2canvas: { scale: 0.22 },
      // autoPaging: false,
      x: 13,
      y: 3,
    });
  };

  render() {
    const { jobList } = this.state;
    return (
      <Card>
        <Card.Body>
          <Row>
            <Col>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Job Token</th>
                    <th>Status</th>
                    <th>Invoice Amount</th>
                    <th>Balance</th>
                    <th>Paid</th>
                    <th>Date</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  {jobList.length > 0 &&
                    jobList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.job_token}</td>
                          <td>{item.status}</td>
                          <td>{item.amount}</td>
                          <td>{item.balance}</td>
                          <td>{item.paid}</td>
                          <td>{moment(item.dateAt).format("DD-MM-YYYY")}</td>
                          <td>
                            {item?.balance > 0 && (
                              <Button
                                onClick={() =>
                                  this.handlePay(
                                    index,
                                    item.qbInvoiceId,
                                    item._id,
                                    item.qbCustId
                                  )
                                }
                              >
                                Receive
                              </Button>
                            )}
                            {item.status !== "unpaid" && (
                                <Button
                                  onClick={() =>
                                    this.handleInvoiceReceipts(true, item)
                                  }
                                  className="m-1"
                                >
                                  <FaStreetView />
                                </Button>
                            )}
                            {/* {item.status === "fullypaid" && (
                              <>
                                <Button
                                  onClick={() =>
                                    this.handleInvoice(true, index, item)
                                  }
                                  className="m-1"
                                >
                                  <FaStreetView />
                                </Button>
                                <Button onClick={() => this.downloadPdf(item)}>
                                  <FaDownload />
                                </Button>
                              </>
                            )} */}
                          </td>
                        </tr>
                      );
                    })}

                  {jobList.length === 0 && (
                    <tr className="text-center">
                      <td colSpan={7}> Not Found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>

          <Modal
            size="sx"
            show={this.state.showModal}
            onHide={() => this.handleShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            centerBtn
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                Receive Invoice Amount
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  name="date"
                  type="date"
                  value={this.state.date}
                  onChange={(e) => this.handleInputChange(e)}
                />
                <div className="text-danger">
                  {this.state.valdate && "Required"}
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Account Name</Form.Label>
                <Select
                  options={this.state.listSelect}
                  onChange={(e) => this.handleInputChange(e)}
                />
                <div className="text-danger">
                  {this.state.valaccount_name && "Required"}
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  name="amount"
                  type="number"
                  value={this.state.amount}
                  onChange={(e) => this.handleInputChange(e)}
                />
                <div className="text-danger">
                  {this.state.valamount && "Required"}
                </div>
              </Form.Group>
              <div className="w-100 d-flex justify-content-center mt-4">
                <Button
                  size="sx"
                  variant="secondary"
                  style={{ width: "100px" }}
                  className="me-3"
                  onClick={() => this.handleShow(false)}
                >
                  Cancel
                </Button>
                <Button
                  size="sx"
                  style={{ width: "100px" }}
                  onClick={() => this.payInvoice()}
                >
                  Receive
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </Card.Body>
        {/* //  {invoices && invoices.length > 0 && ( */}
        <Modal
          size="xl"
          show={this.state.showInvoiceModal}
          onHide={() => this.handleInvoice(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              Payment Receipt
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.showInvoiceModal && 
              <ReceiptHtml data={this.state.data} receiptIndex={this.state.receiptIndex} />
            }
          </Modal.Body>
        </Modal>
        <Modal
          size="md"
          show={this.state.showReceiptModal}
          onHide={() => this.handleInvoiceReceipts(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              Invoice Receipts
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>#</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state?.data?.receipts && Array.isArray(this.state.data.receipts) && 
                  this.state.data.receipts.length>0 && this.state.data.receipts.map((item, index) => (
                      <tr key={index}>
                        <td>{index+1}</td>
                        <td>{item?.created_date ? moment(item.created_date).format("DD-MM-YYYY") : "-"}</td>
                        <td>{item?.amount || 0}</td>
                        <td>
                          <Button
                            onClick={() =>
                              this.handleInvoice(true, index)
                            }
                            className="m-1"
                          >
                            <FaStreetView />
                          </Button>
                          <Button onClick={() =>   this.downloadPdf(index)}>
                            <FaDownload />
                          </Button>
                        </td>
                      </tr>
                    ))) || (this.state.data ? (<tr>
                      <td>1</td>
                      <td>{moment(this.state.data?.dateAt).format("DD-MM-YYYY")}</td>
                      <td>{this.state.data?.paid}</td>
                       <td>
                          <Button
                            onClick={() =>
                              this.handleInvoice(true, null)
                            }
                            className="m-1"
                          >
                            <FaStreetView />
                          </Button>
                          <Button onClick={() =>   this.downloadPdf(null)}>
                            <FaDownload />
                          </Button>
                        </td>
                      </tr>) : (<tr>
                      <td colSpan={4}>No Receipt Found</td>
                      </tr>))}
                  </tbody>
              </Table>
          </Modal.Body>
        </Modal>
      </Card>
    );
  }
}

export { InvoiceByJob };
